// **************************
// *** MeusAgendamentos (em aberto) abertos.jsx 
// *** autor: Walcledson de Paula
// *** MVinfo Sistemas & Automação
// *** 09/06/24
// *** 4/7/24 | 09h39 → acrescentado o token criptografado
// **************************

import { useEffect, useState } from "react";
import { Oval } from 'react-loader-spinner';  // Import the loading spinner
import apiaxios from "../../../../Services/apiaxios.js";
import { decrypt } from "../../../../Services/cryptoUtils.js";
import Swal from 'sweetalert2';
import withReactContent from 'sweetalert2-react-content';
import handleApiError from "../../../../Services/apiErrorHandler.js";
import autoLogout from "../../components/Login/autologout.js";

import Menu from "../../components/Menu/menu.jsx";
import CardAgendamentos from "../../components/Agendamentos/agendamentos.jsx";
import Footer from "../../components/Footer/footer.jsx";

import './abertos.css';

function MeusAgendamentos() {
    // const tokenASW = localStorage.getItem("tokenasw");
    const tokenASW = decrypt(localStorage.getItem('tokenasw'));
    const tokenlg = localStorage.getItem("tokenlg");
    useEffect(() => {
        if (!tokenASW || !tokenlg) {
            autoLogout();
        }
    }, [tokenASW, tokenlg]);

    const getInitialUserData = () => {
        const encryptedUser = localStorage.getItem('tokenacw');
        if (encryptedUser) {
            try {
                const decryptedUser = decrypt(encryptedUser);
                return {
                    userId: decryptedUser.id_usuario || 0,
                    tam_pagina: decryptedUser.TAMANHO_PAGINA || 10
                };
            } catch (error) {
                console.error('Erro ao descriptografar ou fazer o parse dos dados:', error);
                return { userId: 0, tam_pagina: 10 };
            }
        }
        return { userId: 0, tam_pagina: 10 };
    };

    const initialUserData = getInitialUserData();
    const [tamanho_pagina, setTamanho_pagina] = useState(initialUserData.tam_pagina);
    const [id_usuario, setId_usuario] = useState(initialUserData.userId);

    const [nenhumAgendamentoAbertoEncontrado, setNenhumAgendamentoAbertoEncontrado] = useState(false);
    const [loading, setLoading] = useState(false);
    const [agendamentos, setAgendamentos] = useState([]);
    const [pagina, setPagina] = useState(1);
    const [hasMore, setHasMore] = useState(true);
    const MySwal = withReactContent(Swal);

    useEffect(() => {
        atualizarAgendamentos(pagina);
    }, [pagina]);

    const atualizarAgendamentos = async (pagina) => {
        setLoading(true);
        const url = `reserva/listar?id_usuario=${id_usuario}&pagina=${pagina}&tamanho_pagina=${tamanho_pagina}&id_status1=1`;
        try {
            const response = await apiaxios.get(url);
            setLoading(false);

            if (response.data.retorno) {
                Swal.fire('Erro', 'Erro ao carregar agendamentos: ' + response.data.retorno, 'error');
            } else {
                if (response.data.length === 0) {
                    setNenhumAgendamentoAbertoEncontrado(true);
                    MySwal.fire({
                        toast: true,
                        position: 'top-end',
                        showConfirmButton: false,
                        timer: 3000,
                        timerProgressBar: true,
                        icon: 'info',
                        title: 'Nenhum agendamento em aberto, encontrado neste momento...'
                    });
                    setHasMore(false);
                } else {
                    setNenhumAgendamentoAbertoEncontrado(false);
                    setAgendamentos(prevDados => [...prevDados, ...response.data]);
                    if (response.data.length < tamanho_pagina) {
                        setHasMore(false);
                    }
                }
            }
        } catch (error) {
            setLoading(false);
            handleApiError(error);
        }
    };

    const handleExcluir = (agendamento) => {
        const ID_RESERVA = agendamento.agendamento_id;
        const DATA_RESERVA_STRING = agendamento.agendamento_data;

        const [datePart, timePart] = DATA_RESERVA_STRING.split(' ');
        const [day, month, year] = datePart.split('/');
        const [hours, minutes, seconds] = timePart.split(':');
        const DATA_RESERVA = new Date(year, month - 1, day, hours, minutes, seconds);

        const dataAtual = new Date();

        if (!dataAtual) {
            console.error('Erro: dataAtual está indefinido');
            return;
        }

        if (DATA_RESERVA < dataAtual) {
            Swal.fire('Atenção', 
                        'Prazo para exclusão vencido. Agendamento em análise!', 
                        'warning');
                return;
        } else if (DATA_RESERVA.toDateString() === dataAtual.toDateString() && 
            dataAtual.getHours() >= DATA_RESERVA.getHours() - 2) {
            Swal.fire('Atenção', 
                        'Prazo para exclusão vencido. Não falte ao compromisso com o prestador de serviços!',
                        'warning');
                return;
        } else if (DATA_RESERVA.toDateString() === dataAtual.toDateString() && 
            dataAtual.getHours() >= DATA_RESERVA.getHours() && 
            dataAtual.getHours() < DATA_RESERVA.getHours() + 3) {
            Swal.fire('Atenção', 
                        'Prazo para exclusão vencido. Você já deve estar dentro do atendimento!', 
                        'warning');
                return;
        }

        Swal.fire({
            title: 'Excluir Agendamento',
            html: `
                <label for="motivo">Motivo do Cancelamento:</label>
                <textarea id="motivo" class="swal2-textarea" placeholder="Digite o motivo" minlength="10"></textarea>
                <p>ID_RESERVA: ${ID_RESERVA}</p>
                <p>Data/Hora exclusão: ${dataAtual.toLocaleString()}</p>
            `,
            showCancelButton: true,
            confirmButtonText: 'Excluir',
            cancelButtonText: 'Cancelar',
            preConfirm: () => {
                const motivo = Swal.getPopup().querySelector('#motivo').value;
                if (!motivo || motivo.length < 10) {
                    Swal.showValidationMessage('Para cancelar seu agendamento, você precisa primeiro dizer o motivo (mínimo 10 caracteres)');
                    return false;
                }
                return motivo;
            }
        }).then((result) => {
            if (result.isConfirmed) {
                const motivo = result.value;
                const id_usuario = JSON.parse(localStorage.getItem("tokenacw")).id_usuario;

                apiaxios.put('reserva/excluir', {
                    id_reserva: ID_RESERVA,
                    tipo_exclusao: 'C',
                    id_usuario,
                    obs_cancel: motivo
                })
                .then(response => {
                    if (response.status === 200 && response.data.retorno === "OK") {
                        Swal.fire('Excluído!', 'Seu agendamento foi excluído.', 'success');
                        setAgendamentos(agendamentos.filter(a => a.ID_RESERVA !== agendamento.ID_RESERVA));
                    } else {
                        Swal.fire('Erro', response.data.retorno || 'Erro ao excluir agendamento', 'error');
                    }
                })
                .catch(error => {
                    Swal.fire('Erro', 'Erro ao excluir agendamento: ' + error, 'error');
                });
            }
        });
    };

    return (
        <>
            <div className="topo-margin">
                <div className="container-fluid">
                    <div className="row flex-nowrap">
                        <div className="col-auto col-md-3 col-xl-2 px-sm-2 px-0">
                            <Menu page="agendamentosabertos" />
                        </div>
                        <div className="col py-2 me-3">
                            <div className="container-fluid">
                                <h1 className="text-center">Meus Agendamentos</h1>
                                <div className="row">
                                    {loading && (
                                        <div className="loading-spinner-container">
                                            <Oval color="#00BFFF" height={80} width={80} />
                                        </div>
                                    )}
                                    {nenhumAgendamentoAbertoEncontrado ? (
                                        <div className="alert alert-danger mt-10" role="alert">
                                            Nenhum "Agendamento" disponível neste momento...
                                        </div>
                                    ) : (
                                        <div className="box-agendamentos">
                                            <table className="table">
                                                <thead>
                                                    <tr>
                                                        <th>Id.Reserva</th>
                                                        <th>Descrição</th>
                                                        <th>Nome Empresa</th>
                                                        <th>Endereço Empresa</th>
                                                        <th>Fone Empresa</th>
                                                        <th>Data</th>
                                                        <th>Hora</th>
                                                        <th>Valor</th>
                                                        <th className="text-right">Status</th>
                                                        <th className="text-right">Ações</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {/* {agendamentos.map(agendamento => ( */}
                                                    {agendamentos.map((agendamento, index) => (
                                                        <CardAgendamentos
                                                            // key={agendamento.ID_RESERVA}
                                                            key={`${agendamento.ID_RESERVA}-${index}`}
                                                            agendamento={{
                                                                agendamento_id: agendamento.ID_RESERVA,
                                                                agendamento_descricao: agendamento.DESCRICAO,
                                                                agendamento_nome: agendamento.NOME,
                                                                agendamento_data: agendamento.DATA_RESERVA,
                                                                agendamento_hora: agendamento.HORA,
                                                                agendamento_vr: agendamento.VALOR,
                                                                agendamento_endereco: `${agendamento.ENDERECO} ${agendamento.BAIRRO} - ${agendamento.CIDADE}`,
                                                                agendamento_fone: agendamento.FONE,
                                                                agendamento_status: `${agendamento.ID_STATUS} : ${agendamento.ST_DESCRICAO}`
                                                            }}
                                                            showExcluir={true}
                                                            showAvaliar={false}
                                                            showMotivo={false}
                                                            handleExcluir={handleExcluir}
                                                        />
                                                    ))}
                                                </tbody>
                                            </table>
                                        </div>
                                    )}
                                </div>
                                {hasMore && (
                                    <div className="load-more">
                                        <button onClick={() => setPagina(prevPagina => prevPagina + 1)}>Carregar mais</button>
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <Footer />
        </>
    );
}

export default MeusAgendamentos;
